import { render, staticRenderFns } from "./BasePick.vue?vue&type=template&id=67f855ac&"
import script from "./BasePick.vue?vue&type=script&lang=js&"
export * from "./BasePick.vue?vue&type=script&lang=js&"
import style0 from "./BasePick.vue?vue&type=style&index=0&id=67f855ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports